export default function getCurrentDate(separator=''){
    let newDate = new Date()
    let date = newDate.getDate().toString().length === 1 ? `0${newDate.getDate()}` : newDate.getDate();
    let month = newDate.getMonth() + 1;
    let year = newDate.getFullYear();

    return `${year}${separator}${month<10?`0${month}`:`${month}`}${separator}${date}`
}